// Russisches Wörterbuch — `Dict` erzwingt Vollständigkeit.
import type { Dict } from "./de";

export const ru: Dict = {
  meta: {
    title: "Pulpo: цифровое меню для вашего ресторана",
    description:
      "Гости сканируют QR-код на столе и видят ваше меню на телефоне: на своём языке, с фото и актуальными ценами.",
  },
  nav: { login: "Войти" },
  hero: {
    eyebrow: "Цифровое меню для вашего ресторана",
    title: "Ваше меню. Любой язык. Всегда актуально.",
    sub: "Гости сканируют QR-код на столе и видят ваше меню на телефоне: на своём языке, с фото и актуальными ценами. Вы управляете всем в одном месте.",
    ctaStart: "Начать бесплатно",
    ctaDemo: "Посмотреть пример меню",
  },
  steps: {
    title: "Как это работает",
    items: [
      {
        title: "Зарегистрируйтесь и внесите блюда",
        body: "Категории, цены, фото. Прямо в браузере, ничего устанавливать не нужно.",
      },
      {
        title: "QR-код на стол",
        body: "Распечатайте код, и готово. Гостям не нужно приложение.",
      },
      {
        title: "Меняйте, когда что-то меняется",
        body: "Новая цена, блюдо дня: онлайн за секунды, без перепечатки.",
      },
    ],
  },
  included: {
    title: "Всё включено",
    hint: "Что умеет ваше меню, без доплат.",
    price: "включено",
    items: [
      {
        name: "Меню на нескольких языках",
        note: "с автоматическим переводом для гостей со всего мира",
      },
      {
        name: "Фото, аллергены и пометки",
        note: "каждое блюдо с картинкой и понятной маркировкой",
      },
      {
        name: "Цены меняются за секунды",
        note: "без типографии и наклеек",
      },
      {
        name: "QR-код для печати",
        note: "на стол, на дверь или на флаер",
      },
      {
        name: "Собственный сайт и домен",
        note: "ваше меню живёт под вашим именем",
      },
      {
        name: "Гостям не нужно приложение",
        note: "сканируют, читают, заказывают как обычно",
      },
    ],
  },
  pricing: {
    title: "Счёт, пожалуйста",
    hint: "Цифровое меню бесплатно.",
    lines: [
      { name: "Цифровое меню", price: "0 €" },
      { name: "Стандартный сайт с меню и контактами", price: "0 €" },
      { name: "Подключение собственного домена", price: "0 €" },
      { name: "Реклама", price: "нет" },
    ],
    totalLabel: "Итого в месяц",
    total: "0 €",
    note: "Создайте ресторан, и меню сразу онлайн. Спасибо за визит!",
    extrasTitle: "По желанию",
    extras: [
      { name: "Поддержка в чате и по почте", price: "9 € / месяц" },
      { name: "Индивидуальный сайт, сделаем под вас", price: "разово, от 490 €" },
    ],
  },
  finale: {
    title: "Онлайн уже сегодня вечером?",
    sub: "Создайте ресторан, внесите блюда, и меню сразу доступно по вашему собственному адресу.",
    cta: "Начать бесплатно",
  },
  phone: {
    restaurant: "Casa Pulpo",
    menuTitle: "Меню",
    category: "Рекомендуем",
    dishes: [
      { name: "Суп дня", price: "6,50 €" },
      { name: "Осьминог на гриле", price: "18,90 €" },
      { name: "Шоколадный торт", price: "7,20 €" },
    ],
  },
};
